import React, { useState } from 'react';
import classnames from 'classnames';
import Tooltip from 'shared/components/Tooltip';
import Label from 'shared/components/Label';

const FileLabel = (props) => {
  const {
    label,
    name,
    required,
    tooltip,
  } = props;

  if (label === null || label === '') {
    return null;
  }
  return (
    <Label
      label={label}
      required={required}>
      <Tooltip id={`tooltip-${name}`} title={tooltip} />
    </Label>
  );
};

const FileComponent = (props) => {
  const {
    fileName: initialFileName,
    name,
    text,
    isFileRequired,
    processFile,
    onChangeParameter,
    inputClassName,
    btnClassName,
    groupName,
    inputId,
  } = props;

  const [fileName, setFileName] = useState(initialFileName);

  const className = classnames({
    'ignore-validate': !isFileRequired,
  }, inputClassName);

  const uploadFile = (event) => {
    const file = event.target.files[0];
    const filename = file ? file.name : '';
    setFileName(filename);
    onChangeParameter(name, filename);
    if (processFile) {
      processFile(file);
    }
  };

  return (
    <div className="btn-file d-grid">
      <FileLabel {...props} />
      <div className={btnClassName}>
        {text}
        <input
          id={inputId}
          type="file"
          className={className}
          name={`${groupName}[${name}]`}
          onChange={uploadFile} />
      </div>
      <div>{fileName}</div>
    </div>
  );
};

FileComponent.defaultProps = {
  name: 'filename',
  groupName: 'parameters',
  label: 'FileComponent',
  text: Spree.translations.upload_file,
  fileName: '',
  inputId: null,
  btnClassName: 'btn btn-filename w-100',
};

export default FileComponent;
